import React from "react";

const TONE_CLASS = {
  neutral: "",
  success: "pf-metric--success",
  danger: "pf-metric--danger",
};

const formatCurrency = (value, currency = "SAR") => {
  if (value === null || value === undefined || Number.isNaN(value)) return null;
  const num = Number(value);
  if (!Number.isFinite(num)) return null;
  return `${num.toFixed(2)} ${currency}`;
};

const MetricsStrip = ({ metrics }) => {
  return (
    <div className="pf-metrics" role="group" aria-label="Pricing preview">
      {metrics.map((m) => {
        const toneClass = TONE_CLASS[m.tone] || "";
        const displayValue = m.value ?? "—";
        return (
          <div className={`pf-metric ${toneClass}`} key={m.key}>
            <div className="pf-metric__label">{m.label}</div>
            <div
              className={`pf-metric__value ${
                displayValue === "—" ? "pf-metric__value--muted" : ""
              }`}
            >
              {displayValue}
            </div>
            {m.meta ? <div className="pf-metric__meta">{m.meta}</div> : null}
          </div>
        );
      })}
    </div>
  );
};

export { formatCurrency };
export default MetricsStrip;
